import { render, staticRenderFns } from "./PoliticaPrivacidade.vue?vue&type=template&id=2edec755&scoped=true"
import script from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"
export * from "./PoliticaPrivacidade.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/legal.css?vue&type=style&index=0&id=2edec755&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edec755",
  null
  
)

export default component.exports